import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {

};
const getters = {};

const mutations = {

};

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions: {},
    strict: process.env.NODE_ENV !== "production",
});

export default store;